import { useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";
import Swal from "sweetalert2";
import { useUsuario } from "../../context/usuarioContext";

const apiContratos = async (x) => {
  /* /sucursalVirtual/contratos */
  const { data } = await clienteAxios.post("sucursalVirtual/contratos", x);
  return data;
};

const useContratos = () => {
   
  return useMutation(apiContratos, {
    onSuccess: (response) => {
      return response
    },
    onError: (error) => {
      return error
    },
  });
};

export default useContratos;